export default __webpack_public_path__ + "static/VTTuinen-popup-vacature-6ebf3f2f0678c231b873460bc9e69906.png";